import { AssistantGrounding } from "@/services/modules/assistant";
import { GroundingMeta } from "./GroundingMeta";
import { renderMarkdown } from "@/lib/markdownRenderer";
import { Loader2 } from "lucide-react";

type Props = {
  streamingText: string;
  streamingGrounding?: AssistantGrounding;
};

export function StreamingBubble({ streamingText, streamingGrounding }: Props) {
  if (!streamingText) {
    return (
      <div className="flex gap-2 items-center">
        <div className="w-6 h-6 rounded-md bg-blue-500 text-white flex items-center justify-center text-[9px] font-bold shrink-0 shadow-xs">
          <Loader2 className="w-3 h-3 animate-spin" />
        </div>
        <div className="flex gap-1 items-center h-5 px-3 py-1 bg-slate-100/80 rounded-full border border-slate-200">
          <span className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce [animation-delay:0ms]" />
          <span className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce [animation-delay:150ms]" />
          <span className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce [animation-delay:300ms]" />
          <span className="text-[10px] text-slate-500 ml-1.5 font-medium">Analisando...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-2 w-full">
      <div className="w-6 h-6 rounded-md bg-blue-500 text-white flex items-center justify-center text-[9px] font-bold shrink-0 mt-0.5 shadow-xs">
        <Loader2 className="w-3 h-3 animate-spin" />
      </div>
      <div className="msg-bubble max-w-[88%] border-blue-200 bg-white shadow-xs">
        <div
          className="text-[12px] leading-relaxed break-words space-y-1"
          dangerouslySetInnerHTML={{ __html: renderMarkdown(streamingText) }}
        />
        <GroundingMeta grounding={streamingGrounding} />
      </div>
    </div>
  );
}
